// extracted by mini-css-extract-plugin
module.exports = {"panel":"_1_5WQ9eG8E5hOVdkHQ9lFK","isHidden":"_2uTY-jPf5hbo15OlUL1D_X","background":"_3ekJJuq990zMWo5JZCbXPj","content":"_3mIUmklnJUhmBkI4chUq_e"};